import { ENGLISH_IQ_DAILY_TARGET_MINUTES } from '@repo/config';
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const dailyTargetMinutesSchema = z.union([
  z.literal(ENGLISH_IQ_DAILY_TARGET_MINUTES[0]),
  z.literal(ENGLISH_IQ_DAILY_TARGET_MINUTES[1]),
  z.literal(ENGLISH_IQ_DAILY_TARGET_MINUTES[2]),
]);

const englishIqRoutineDayV1Schema = z.object({
  check: z.boolean(),
  day: z.number().int().min(1).max(7),
  lessonCount: z.number().int().nonnegative(),
  repetitionCount: z.number().int().nonnegative(),
  skillFocus: z.enum(['grammar', 'meaning', 'listening']).nullable(),
});

const saveEnglishIqPlanV1DataSchema = z.object({
  dailyTargetMinutes: dailyTargetMinutesSchema,
  routine: z.array(englishIqRoutineDayV1Schema).length(7),
});

export type ISaveEnglishIqPlanV1Data = z.infer<typeof saveEnglishIqPlanV1DataSchema>;

export const saveEnglishIqPlanV1ResponseSchema: z.ZodSchema<IAPI<ISaveEnglishIqPlanV1Data>> =
  createApiResponseSchema(saveEnglishIqPlanV1DataSchema) as z.ZodSchema<
    IAPI<ISaveEnglishIqPlanV1Data>
  >;

export type ISaveEnglishIqPlanV1Response = IAPI<ISaveEnglishIqPlanV1Data>;
